export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: "無",
    },
    {
      value: 1,
      name: "SpecificItem",
      text: "購買指定商品",
    },
    {
      value: 2,
      name: "MinSpend",
      text: "最低消費額",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
